<template>
  <modal
    name="course-form"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('course-form')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <div class="fl-msg" />

      <div class="ui-block-title">
        <h6 class="title">
          Course
        </h6>
      </div>

      <div class="ui-block-content">
        <form
          class="content"
          @submit.prevent="submitRow"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Title</strong></p>
              <input
                v-model="item.title"
                class="form-group label-floating"
              >
            </div>
          </div>

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Trainer</strong></p>
              <input
                v-model="item.trainer"
                class="form-group label-floating"
              >
            </div>
          </div>

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Rank</strong></p>
              <input
                v-model="item.rank"
                class="form-group label-floating"
              >
            </div>
          </div>

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Date Begin</strong></p>
              <datepicker
                :value="date_begin"
                class="form-group label-floating"
                @selected="dateSelectedBegin"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <p><strong>Date End</strong></p>
              <datepicker
                :value="date_end"
                class="form-group label-floating"
                @selected="dateSelectedEnd"
              />
            </div>
          </div>




          <button
            class="btn btn-lg btn-breez full-width mt-4"
            type="submit"
            name="submit"
          >
            <span>{{ item.id ? 'Edit' : 'Add' }} Course</span>
          </button>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { EventBus } from '../../../event-bus'
import Datepicker from 'vuejs-datepicker'

 import VModal from 'vue-js-modal';
 import Vue from 'vue'
// import wysiwyg from 'vue-wysiwyg'
// // import '../../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'
 Vue.use(VModal, {dialog: true});
// Vue.use(wysiwyg, {
//   // { [module]: boolean (set true to hide) }
//   hideModules: {
//     bold: false,
//     italic: false,
//     underline: false,
//     justifyLeft: true,
//     justifyCenter: true,
//     justifyRight: true,
//     headings: true,
//     link: false,
//     code: false,
//     orderedList: true,
//     unorderedList: true,
//     image: false,
//     table: true
//   },
//   // image: {
//   //   uploadURL: IMAGE_URL,
//   //   dropzoneOptions: {}
//   // },
//   forcePlainTextOnPaste: true
// })


const MODAL_HEIGHT = 800

import AppIcon from "../../common-apps/common/AppIcon"
import courseStore from "../../../store/modules/spiritual/course";

export default {
  name: 'CourseForm',
  components: { AppIcon, Datepicker },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      item: {
        title: '',
        trainer: '',
        rank: 0,
      },
      date_begin: new Date(),
      date_end: new Date(),
    }
  },
  created () {
    if (!this.$store.hasModule('course')) {
      this.$store.registerModule('course', courseStore)
    }
    this.modalHeight = window.innerHeight < MODAL_HEIGHT
        ? MODAL_HEIGHT - 200
        : MODAL_HEIGHT

    EventBus.$on('close-modal', () => {
      this.$modal.hide('course-form')
    })
  },
  beforeDestroy () {
    this.$store.unregisterModule('course')
  },
  methods: {
    dateSelectedBegin (date) {
      this.date_begin = date
    },
    dateSelectedEnd (date) {
      this.date_end = date
    },
    beforeOpen (event) {
      if (event.params.item) {
        this.item = event.params.item
        this.date_begin = new Date(event.params.item.date_begin)
        this.date_end = new Date(event.params.item.date_end)
      }
    },
    // eslint-disable-next-line
    submitRow: function() { // !!!! this messes up if I use arrow function
      const payload = this.item
      payload.date_begin = new Date(this.date_begin)
      payload.date_end = new Date(this.date_end)
      if (this.item.id) {
        this.$store.dispatch('course/edit', {payload, id: this.item.id})
      } else {
        this.$store.dispatch('course/add', payload)
      }
    }
  }
}
</script>
